import {
    LinguisticLab,
    AudioTranscription,
    AssessmentDef,
    Assessment,
    CreateAssessments,
    Tutorials,
    AssessmentDefs,
    Users,
    TranscriptionSystem,
    Assessments,
    TestTakers,
    Normalizer,
    AffiliationSteup,
    Dashboard,
    Report,
    EmailSignature,
    Newsletter,
    CreateNewsletter,
    MatchingLearning,
    PerformAssessments,
    ViewNewsletter,
    PerformAssessment,
    WordReadability,
    Tickets,
    Ticket,
    AssessmentLibrary,
    CreateAssessmentDef,
    AssessmentResultsTracking,
    AssessmentExecutionTracking,
    AchievementGraph,
    ProgressGraphs,
    Affiliations,
    PracticesAssessments,
    CreatePracticesAssessments,
    SystemReview,
    CreateBattery,
    StuckReasons
} from 'pages'
import {
    transcription,
    rating,
    matchingLearning,
    assessmentDefs,
    testTakers,
    assessments,
    performAssessments,
    createAssessments,
    assessmentDef,
    adminAssessments,
    markingWords,
    cutAudio,
    assessmentView,
    makingRecordAssessments,
    learningResources,
    audioTranscription,
    linguisticLab,
    audioCutting,
    dashboard,
    app,
    payments,
    contactUs,
    users,
    newsletter,
    newsletters,
    tickets,
    assessmentLibrary,
    assessmentsStatus,
    assessmentExecutionTracking,
    achievementGraph,
    progressGraphs,
    school,
    affiliations,
    affiliationSetup,
    practiceAssessments,
    createPracticeAssessments,
    assessmentVersions,
    systemReview,
    trainingDuplicateAssessments,
    primaryAssessments,
    createBattery,
    assessmentCosts,
    stuckReasons
} from "router/routes";
import { AssessmentDefs as AudioTranscriptionAssessments } from 'pages/School/AudioTranscription';
import { ExistAssessmentAlert } from 'pages/School/PerformAssessment';
import { User } from 'pages/Admin/Users'
import { features } from 'keys';
import { systemTypes } from 'keys/systems';
import { SIDEBAR_NAMES } from 'components/SideBar/constants';
import { Transcription, MarkingWords, MarkingWordsAssessments, TranscriptionAssessments, AudioCuttingAssessments, AudioCutting, AssessmentVersions, TrainingAssessmentVersions, AssessmentCosts } from "pages"
import School from 'pages/School/AffiliationManagement/';
import BetweenAssessmentsScreen from 'pages/School/PerformAssessment/BetweenAssessmentsScreen';
import CompleteScreen from 'pages/School/PerformAssessment/CompleteScreen';
import MicCheckPage from 'pages/School/PerformAssessment/MicCheckPage';

const useAppRoutes = () => {

    const permissionParams = {
        permissionHOC: "hidden",
        role: "read"
    }

    const appRoutes = [
        // ==========================================
        // 100 - לוח בקרה ומסכי בסיס
        // ==========================================
        {
            id: 101,
            path: dashboard,
            element: Dashboard,
            feature: "dashboard",
            isGeneralPage: true,
            // title: "לוח בקרה",
            system: systemTypes.school,
            sideBarItem: SIDEBAR_NAMES.dashboard,
            ...permissionParams
        },

        // ==========================================
        // 200 - ניהול לקוחות, בתי ספר, צוות ותלמידים
        // ==========================================
        {
            id: 201,
            path: affiliations,
            element: Affiliations,
            feature: features.test_takers,
            isGeneralPage: true,
            system: systemTypes.school,
            title: "ניהול לקוחות",
            sideBarItem: SIDEBAR_NAMES.affiliations,
            ...permissionParams
        },
        {
            id: 202,
            path: `/${affiliations}/:affiliationGroupID/new`,
            element: School,
            isGeneralPage: true,
            feature: features.school_setup,
            title: "לקוחות",
            system: systemTypes.school,
            breadcrumbs: true,
            featurePath: affiliations,
            sideBarItem: SIDEBAR_NAMES.affiliations,
            ...permissionParams
        },
        {
            id: 203,
            path: app.affiliationById,
            element: School,
            isGeneralPage: true,
            feature: features.test_takers,
            title: "לקוחות",
            breadcrumbs: true,
            featurePath: affiliations,
            system: systemTypes.school,
            sideBarItem: SIDEBAR_NAMES.affiliations,
            ...permissionParams
        },
        {
            id: 204,
            path: `/affiliations/:affiliationID/staff/:userID`,
            element: User,
            breadcrumbs: true,
            title: "צוות בית הספר",
            isGeneralPage: true,
            system: systemTypes.school,
            feature: features.school_setup,
            sideBarItem: SIDEBAR_NAMES.affiliationManagement,
            ...permissionParams
        },
        {
            id: 205,
            path: `/affiliations/:affiliationID/staff/new`,
            element: User,
            breadcrumbs: true,
            title: "צוות בית הספר",
            isGeneralPage: true,
            system: systemTypes.school,
            feature: features.school_setup,
            sideBarItem: SIDEBAR_NAMES.affiliationManagement,
            ...permissionParams
        },
        {
            id: 206,
            path: users,
            element: Users,
            isGeneralPage: true,
            feature: "users",
            title: "משתמשים",
            system: systemTypes.school,
            breadcrumbs: true,
            sideBarItem: SIDEBAR_NAMES.users,
            ...permissionParams
        },
        {
            id: 207,
            path: app.createUser,
            element: User,
            breadcrumbs: true,
            featurePath: users,
            title: "משתמשים",
            system: systemTypes.school,
            isGeneralPage: true,
            feature: "user",
            sideBarItem: SIDEBAR_NAMES.users,
            ...permissionParams
        },
        {
            id: 208,
            path: app.editUser,
            element: User,
            breadcrumbs: true,
            featurePath: users,
            title: "משתמשים",
            isGeneralPage: true,
            feature: "users",
            system: systemTypes.school,
            sideBarItem: SIDEBAR_NAMES.users,
            ...permissionParams
        },
        {
            id: 209,
            path: testTakers,
            element: TestTakers,
            isGeneralPage: true,
            feature: "test-takers",
            title: "תלמידים",
            system: systemTypes.school,
            sideBarItem: SIDEBAR_NAMES.testTakers,
            ...permissionParams
        },

        // ==========================================
        // 300 - ביצוע מבדקים ותרגולים (צד תלמיד/בוחן)
        // ==========================================
        {
            id: 301,
            path: performAssessments,
            element: PerformAssessments,
            isGeneralPage: true,
            feature: "perform-assessments",
            system: systemTypes.school,
            title: "מבדקים פעילים",
            sideBarItem: SIDEBAR_NAMES.performAssessments,
            ...permissionParams
        },
        {
            id: 302,
            path: app.performAssessmentById,
            element: PerformAssessment,
            isGeneralPage: true,
            system: systemTypes.school,
            hideAlerts: true,
            exitAlert: ExistAssessmentAlert,
            feature: "perform-assessment",
            title: "",
            sideBarItem: SIDEBAR_NAMES.performAssessments,
            ...permissionParams
        },
        {
            id: 303,
            path: app.performAssessmentPreviewById,
            element: PerformAssessment,
            isGeneralPage: true,
            exitAlert: ExistAssessmentAlert,
            feature: "perform-assessment",
            system: systemTypes.school,
            title: "",
            hideAlerts: true,
            sideBarItem: SIDEBAR_NAMES.performAssessments,
            ...permissionParams
        },
        {
            id: 304,
            path: "/between/:assessmentID",
            element: BetweenAssessmentsScreen,
            isGeneralPage: true,
            hideAlerts: true,
            system: systemTypes.school,
            sideBarItem: SIDEBAR_NAMES.performAssessments,
            ...permissionParams
        },
        {
            id: 308,
            path: app.micCheck,
            element: MicCheckPage,
            isGeneralPage: true,
            feature: features.all_assessments,
            system: systemTypes.school,
            hideAlerts: true,
            title: "",
            sideBarItem: SIDEBAR_NAMES.performAssessments,
            ...permissionParams
        },
        {
            id: 305,
            path: "complete-screen",
            element: CompleteScreen,
            isGeneralPage: true,
            hideAlerts: true,
            feature: features.all_assessments,
            system: systemTypes.school,
            sideBarItem: SIDEBAR_NAMES.performAssessments,
            ...permissionParams
        },
        {
            id: 306,
            path: practiceAssessments,
            element: PracticesAssessments,
            isGeneralPage: true,
            system: systemTypes.school,
            feature: features.all_assessments,
            title: "תרגולים פעילים",
            sideBarItem: SIDEBAR_NAMES.performPractices,
            ...permissionParams
        },
        {
            id: 307,
            path: app.performPracticesAssessmentById,
            hideAlerts: true,
            element: PerformAssessment,
            isGeneralPage: true,
            system: systemTypes.school,
            exitAlert: ExistAssessmentAlert,
            feature: features.all_assessments,
            title: "",
            sideBarItem: SIDEBAR_NAMES.performPractices,
            ...permissionParams
        },

        // ==========================================
        // 400 - ניהול, ספריות מבדקים ודוחות
        // ==========================================
        {
            id: 401,
            path: assessmentLibrary,
            element: AssessmentLibrary,
            feature: "assessment-library",
            isGeneralPage: true,
            title: "ספרית מבדקים",
            system: systemTypes.administrative,
            sideBarItem: SIDEBAR_NAMES.assessmentLibrary,
            ...permissionParams
        },
        {
            id: 402,
            path: app.createAssessmentDef,
            element: CreateAssessmentDef,
            feature: "assessment-library",
            breadcrumbs: true,
            title: "ספרית מבדקים",
            featurePath: assessmentLibrary,
            isGeneralPage: true,
            system: systemTypes.administrative,
            sideBarItem: SIDEBAR_NAMES.createAssessmentDef,
            ...permissionParams
        },
        {
            id: 403,
            path: app.editAssessmentDef,
            element: CreateAssessmentDef,
            feature: "assessment-library",
            breadcrumbs: true,
            title: "ספרית מבדקים",
            featurePath: assessmentLibrary,
            isGeneralPage: true,
            system: systemTypes.administrative,
            sideBarItem: SIDEBAR_NAMES.createAssessmentDef,
            ...permissionParams
        },
        {
            id: 404,
            path: createAssessments,
            element: CreateAssessments,
            feature: features.assessment_library,
            title: "הקצאת מבדקים",
            system: systemTypes.administrative,
            isGeneralPage: true,
            sideBarItem: SIDEBAR_NAMES.createAssessments,
            ...permissionParams
        },
        {
            id: 405,
            path: createPracticeAssessments,
            element: CreatePracticesAssessments,
            isGeneralPage: true,
            feature: "perform-assessments",
            system: systemTypes.school,
            title: "התאמת תרגולים לתלמיד",
            sideBarItem: SIDEBAR_NAMES.createPractices,
            ...permissionParams
        },
        {
            id: 406,
            path: assessmentDefs,
            element: AssessmentDefs,
            feature: "assessment-defs",
            title: "מבדקים",
            system: systemTypes.school,
            sideBarItem: SIDEBAR_NAMES.assessments,
            ...permissionParams
        },
        {
            id: 407,
            path: `${assessmentDefs}/:assessmentDefID`,
            element: AssessmentDef,
            feature: "assessment-defs",
            title: "קריאה מותאמת",
            system: systemTypes.school,
            sideBarItem: SIDEBAR_NAMES.assessments,
            ...permissionParams
        },
        {
            id: 408,
            path: assessmentDef,
            element: AssessmentDef,
            feature: "assessment-def",
            system: systemTypes.school,
            title: "",
            sideBarItem: SIDEBAR_NAMES.assessments,
            ...permissionParams
        },
        {
            id: 409,
            path: assessments,
            element: Assessments,
            isGeneralPage: true,
            feature: "assessments",
            breadcrumbs: true,
            system: systemTypes.school,
            title: "דוחות",
            sideBarItem: SIDEBAR_NAMES.assessments,
            ...permissionParams
        },
        {
            id: 410,
            path: `${assessments}/:assessmentID`,
            element: Report,
            feature: "assessment",
            breadcrumbs: true,
            system: systemTypes.school,
            sideBarItem: SIDEBAR_NAMES.assessments,
            ...permissionParams
        },
        {
            id: 411,
            path: assessmentView,
            element: Assessment,
            feature: "assessment",
            system: systemTypes.school,
            title: "",
            sideBarItem: SIDEBAR_NAMES.assessments,
            ...permissionParams
        },
        {
            id: 412,
            path: `${assessmentView}/:assessmentID`,
            element: Assessment,
            feature: "assessment",
            title: "",
            system: systemTypes.school,
            sideBarItem: SIDEBAR_NAMES.assessments,
            ...permissionParams
        },
        {
            id: 413,
            path: rating,
            element: Report,
            feature: "rating",
            system: systemTypes.school,
            sideBarItem: SIDEBAR_NAMES.assessments,
            ...permissionParams
        },
        {
            id: 414,
            path: `${matchingLearning}/:assessmentID`,
            element: MatchingLearning,
            feature: "matching-learning",
            title: "דוח אישי",
            breadcrumbs: true,
            system: systemTypes.school,
            featurePath: assessments,
            sideBarItem: SIDEBAR_NAMES.assessments,
            ...permissionParams
        },
        {
            id: 415,
            path: createBattery,
            element: CreateBattery,
            feature: features.assessment_library,
            title: "יצירת סוללה",
            system: systemTypes.administrative,
            isGeneralPage: true,
            sideBarItem: SIDEBAR_NAMES.createBattery,
            ...permissionParams
        },

        // ==========================================
        // 500 - סקירה מערכתית (מעקב ביצועים וגרפים - Nested Routes)
        // ==========================================
        {
            id: 500,
            path: `/${systemReview}`,
            element: SystemReview,
            feature: features.general_performance_review,
            isGeneralPage: true,
            system: systemTypes.school,
            sideBarItem: SIDEBAR_NAMES.systematicReview,
            // כאן אפשר להגדיר sideBarItem של האב אם התפריט נפתח
            ...permissionParams,
            children: [
                {
                    id: 501,
                    path: assessmentExecutionTracking, // חשוב: לוודא שהמשתנה הזה לא מתחיל בלוכסן בקובץ routes.js!
                    element: AssessmentExecutionTracking,
                    title: "ביצוע מבדקים",
                    isGeneralPage: true,
                    sideBarItem: SIDEBAR_NAMES.assessmentExecution,
                    feature: features.general_performance_review, // הועתק מהאב ליתר ביטחון
                    ...permissionParams
                },
                {
                    id: 502,
                    path: assessmentsStatus,
                    element: AssessmentResultsTracking,
                    title: "מצב הקריאה",
                    isGeneralPage: true,
                    sideBarItem: SIDEBAR_NAMES.generalPerformanceReview,
                    feature: features.general_performance_review,
                    ...permissionParams
                },
                {
                    id: 503,
                    path: achievementGraph,
                    element: AchievementGraph,
                    isGeneralPage: true,
                    title: "מעקב התקדמות",
                    sideBarItem: SIDEBAR_NAMES.achievementGraph,
                    feature: features.general_performance_review,
                    ...permissionParams
                },
                {
                    id: 504,
                    path: progressGraphs,
                    element: ProgressGraphs,
                    isGeneralPage: true,
                    title: "גרף שיפור הישגים - השוואה לפי שיטות התערבות",
                    sideBarItem: SIDEBAR_NAMES.progressGraphs,
                    feature: features.general_performance_review,
                    ...permissionParams
                },
                {
                    // ניתוב ברירת מחדל: מה קורה אם המשתמש נכנס רק ל /performance-review?
                    // נפנה אותו אוטומטית למסך הראשון (למשל "ביצוע מבדקים")
                    id: 505,
                    index: true,
                    navigate: app.assessmentExecutionTracking,
                    ...permissionParams
                }
            ]
        },


        // ==========================================
        // 600 - מערכת ניהול ראשי (Nested Routes - Transcription System)
        // ==========================================
        {
            id: 601,
            path: "/manage", // תוקן: ללא כוכבית
            element: TranscriptionSystem,
            isGeneralPage: true,
            system: systemTypes.administrative,
            role: "read",
            feature: "transcription_system",
            sideBarItem: SIDEBAR_NAMES.markingWords,
            ...permissionParams,
            children: [
                {
                    id: 6011,
                    path: primaryAssessments,
                    element: MarkingWordsAssessments,
                    feature: "admin_assessment",
                    isGeneralPage: true,
                    title: "סימון מילים",
                    isTrainingMode: false,
                    sideBarItem: SIDEBAR_NAMES.primaryAssessments,
                    ...permissionParams
                },
                {
                    id: 6012,
                    path: trainingDuplicateAssessments,
                    isTrainingMode: true,
                    element: MarkingWordsAssessments,
                    feature: "admin_assessment",
                    isGeneralPage: true,
                    title: "סימון מילים",
                    sideBarItem: SIDEBAR_NAMES.trainingAssessments,
                    ...permissionParams
                },
                {
                    id: 6013,
                    path: `${primaryAssessments}/:assessmentID`,
                    element: MarkingWords,
                    title: "סימון מילים",
                    hideHeader: true,
                    feature: "admin_assessment",
                    sideBarItem: SIDEBAR_NAMES.primaryAssessments,
                    ...permissionParams
                },
                {
                    id: 6014,
                    path: `${trainingDuplicateAssessments}/:assessmentID`,
                    element: MarkingWords,
                    isTrainingMode: true,
                    hideHeader: true,
                    title: "סימון מילים",
                    feature: "admin_assessment",
                    sideBarItem: SIDEBAR_NAMES.trainingAssessments,
                    ...permissionParams
                },
                {
                    id: 6015,
                    path: `${assessmentVersions}/:assessmentID`,
                    element: AssessmentVersions,
                    title: "גרסאות",
                    feature: "admin_assessment",
                    sideBarItem: SIDEBAR_NAMES.primaryAssessments,
                    ...permissionParams
                },
                {
                    id: 6016,
                    path: `${primaryAssessments}/comparison/:assessmentID`,
                    element: TrainingAssessmentVersions,
                    isTrainingMode: true,
                    title: "השוואת מבדק הדגמה מול מבדק המקור",
                    feature: "admin_assessment",
                    sideBarItem: SIDEBAR_NAMES.markingWords,
                    ...permissionParams
                },
                {
                    id: 6017,
                    path: `${trainingDuplicateAssessments}/comparison/:assessmentID`,
                    element: TrainingAssessmentVersions,
                    isTrainingMode: true,
                    title: "השוואת מבדק הדגמה מול מבדק המקור",
                    feature: "admin_assessment",
                    sideBarItem: SIDEBAR_NAMES.trainingAssessments,
                    ...permissionParams
                },
                {
                    id: 6018,
                    path: audioCutting,
                    element: AudioCuttingAssessments,
                    title: "סימון אודיו",
                    feature: "admin_assessment",
                    isGeneralPage: true,
                    sideBarItem: SIDEBAR_NAMES.audioCutting,
                    ...permissionParams,
                },
                {
                    id: 6019,
                    path: `${audioCutting}/:assessmentID`,
                    element: AudioCutting,
                    title: "סימון אודיו",
                    feature: "admin_assessment",
                    sideBarItem: SIDEBAR_NAMES.audioCutting,
                    ...permissionParams
                },
                {
                    id: 6020,
                    path: transcription,
                    element: TranscriptionAssessments,
                    feature: "admin_assessment",
                    title: "תעתוק",
                    isGeneralPage: true,
                    sideBarItem: SIDEBAR_NAMES.transcription,
                    ...permissionParams,
                },
                {
                    id: 6021,
                    path: `${transcription}/:assessmentID`, // תוקן: ללא לוכסן
                    element: Transcription,
                    feature: "admin_assessment",
                    title: "תעתוק",
                    sideBarItem: SIDEBAR_NAMES.transcription,
                    ...permissionParams
                },
                {
                    id: 6023,
                    path: assessmentCosts,
                    element: AssessmentCosts,
                    feature: "admin_assessment",
                    title: "עלות מבדקים",
                    isGeneralPage: true,
                    sideBarItem: SIDEBAR_NAMES.assessmentCosts,
                    ...permissionParams,
                },
                {
                    id: 6022,
                    index: true, // תוקן: ברירת מחדל לראוט האב
                    navigate: app.markingWordsAssessments,
                    isGeneralPage: true,
                    feature: "admin_assessment",
                    sideBarItem: SIDEBAR_NAMES.markingWords,
                    ...permissionParams
                }
            ]
        },

        // ==========================================
        // 650 - ניהול מערכת (סופר יוזר + מי שקיבל הרשאה ספציפית)
        // ==========================================
        {
            id: 650,
            path: stuckReasons,
            element: StuckReasons,
            isGeneralPage: true,
            title: "סיבות תקיעות",
            system: systemTypes.administrative,
            sideBarItem: SIDEBAR_NAMES.stuckReasons,
            permissionHOC: "hidden",
            role: "manage",
            feature: "stuck_reasons_admin",
        },

        // ==========================================
        // 700 - מעבדות ולשון
        // ==========================================
        {
            id: 701,
            path: app.textReadability,
            element: LinguisticLab,
            title: "מעבדה לשונית",
            isGeneralPage: true,
            feature: "linguistic-lab",
            system: systemTypes.administrative,
            sideBarItem: SIDEBAR_NAMES.textReadability,
            ...permissionParams
        },
        {
            id: 702,
            path: app.wordReadability,
            element: WordReadability,
            title: "מעבדה לשונית",
            isGeneralPage: true,
            system: systemTypes.administrative,
            feature: "linguistic-lab",
            sideBarItem: SIDEBAR_NAMES.wordReadability,
            ...permissionParams
        },
        {
            id: 703,
            path: app.normalizer,
            element: Normalizer,
            title: "קביעת נורמות",
            isGeneralPage: true,
            system: systemTypes.administrative,
            feature: "child-development",
            sideBarItem: SIDEBAR_NAMES.normalizer,
            ...permissionParams
        },
        {
            id: 704,
            path: learningResources,
            element: AudioTranscriptionAssessments,
            isGeneralPage: true,
            feature: "voice-lab",
            system: systemTypes.administrative,
            sideBarItem: SIDEBAR_NAMES.voiceLab,
            ...permissionParams
        },
        {
            id: 705,
            path: app.audioTranscriptionById,
            element: AudioTranscription,
            isGeneralPage: true,
            feature: "voice-lab",
            system: systemTypes.administrative,
            title: "",
            sideBarItem: SIDEBAR_NAMES.voiceLab,
            ...permissionParams
        },
        {
            id: 706,
            path: `${transcription}/:assessmentID`,
            element: Transcription,
            title: "פענוח אודיו",
            sideBarItem: SIDEBAR_NAMES.voiceLab,
            system: systemTypes.administrative,
        },

        // ==========================================
        // 800 - פניות, ניוזלטר והדרכות
        // ==========================================
        {
            id: 801,
            path: tickets,
            element: Tickets,
            isGeneralPage: true,
            feature: "tickets",
            system: systemTypes.school,
            title: "פניות",
            sideBarItem: SIDEBAR_NAMES.tickets,
            ...permissionParams
        },
        {
            id: 802,
            path: app.ticketById,
            element: Ticket,
            isGeneralPage: true,
            featurePath: tickets,
            feature: "tickets",
            system: systemTypes.school,
            breadcrumbs: true,
            title: "פניות",
            sideBarItem: SIDEBAR_NAMES.tickets,
            ...permissionParams
        },
        {
            id: 803,
            path: newsletters,
            element: Newsletter,
            title: "מה חדש?",
            isGeneralPage: true,
            feature: "newsletter",
            system: systemTypes.administrative,
            sideBarItem: SIDEBAR_NAMES.newsletters,
            ...permissionParams
        },
        {
            id: 804,
            path: app.createNewsletter,
            element: CreateNewsletter,
            featurePath: newsletters,
            title: "מה חדש?",
            breadcrumbs: true,
            isGeneralPage: true,
            feature: "newsletter",
            system: systemTypes.administrative,
            sideBarItem: SIDEBAR_NAMES.newsletters,
            ...permissionParams
        },
        {
            id: 805,
            path: app.editNewsletter,
            breadcrumbs: true,
            featurePath: newsletters,
            element: CreateNewsletter,
            system: systemTypes.administrative,
            title: "מה חדש?",
            isGeneralPage: true,
            feature: "newsletter",
            sideBarItem: SIDEBAR_NAMES.newsletters,
            ...permissionParams
        },
        {
            id: 806,
            path: app.newslettersById,
            breadcrumbs: true,
            featurePath: newsletters,
            element: ViewNewsletter,
            system: systemTypes.administrative,
            title: "מה חדש?",
            isGeneralPage: true,
            feature: "newsletter",
            sideBarItem: SIDEBAR_NAMES.newsletters,
            ...permissionParams
        },
        {
            id: 807,
            path: "/tutorials/*",
            element: Tutorials,
            isGeneralPage: true,
            feature: "tutorials",
            system: systemTypes.school,
            hidePadding: true,
            sideBarItem: SIDEBAR_NAMES.tutorials,
            ...permissionParams
        },

        // ==========================================
        // 900 - ניתובים דינמיים וברירות מחדל (Fallbacks)
        // ==========================================
        {
            id: 901,
            path: "/",
            navigate: app.dashboard,
            system: systemTypes.school,
            isGeneralPage: true,
            feature: "dashboard",
            sideBarItem: SIDEBAR_NAMES.dashboard,
            ...permissionParams
        },
        {
            id: 902, // שימו לב: קיים גם id 901 עם path "/", כנראה מרורנדר לפי הרשאות
            path: "/",
            navigate: app.performAssessments,
            isGeneralPage: true,
            system: systemTypes.school,
            feature: "students",
            sideBarItem: SIDEBAR_NAMES.performAssessments,
            ...permissionParams
        },
        {
            id: 903,
            path: `/*`,
            navigate: app.markingWordsAssessments,
            isGeneralPage: true,
            system: systemTypes.administrative,
            role: "read",
            feature: "admin_assessment",
            sideBarItem: SIDEBAR_NAMES.markingWords,
            ...permissionParams
        }
    ]

    return appRoutes
}

export default useAppRoutes
